import React, { useCallback, useState } from "react";
import ScheduleActivityAiSummaryModal from "./ScheduleActivityAiSummaryModal";
import { buildScheduleActivityAiSummary } from "./scheduleActivityAiSummary";

export default function ScheduleActivityAiSummaryButton({
  auditLog = [],
  wizard,
  cohort,
  scheduleCreated = false,
  visitBuilderMode,
  visitCohorts,
  studyScheduleId,
  organizationId,
  createdBy,
  isScheduleLive = false,
  className = "btn btn-sm schedule-activity-log__ai-summary",
  label = "AI Summary",
}) {
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryError, setSummaryError] = useState("");
  const [summary, setSummary] = useState(null);

  const handleAiSummary = useCallback(async () => {
    setSummaryOpen(true);
    setSummaryLoading(true);
    setSummaryError("");
    setSummary(null);
    try {
      const result = await buildScheduleActivityAiSummary({
        auditLog,
        wizard,
        cohort,
        scheduleCreated,
        visitBuilderMode,
        visitCohorts,
        studyScheduleId,
        organizationId,
        createdBy,
        isScheduleLive,
      });
      setSummary(result);
    } catch (err) {
      setSummaryError(err?.message || "Could not generate summary.");
    } finally {
      setSummaryLoading(false);
    }
  }, [
    auditLog,
    cohort,
    createdBy,
    isScheduleLive,
    organizationId,
    scheduleCreated,
    studyScheduleId,
    visitBuilderMode,
    visitCohorts,
    wizard,
  ]);

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={handleAiSummary}
        disabled={summaryLoading}
        title={
          isScheduleLive
            ? "Preview how appointments flow from the first booking and which messages send"
            : "At 100% readiness, preview appointment dates and messages; otherwise see what is still needed"
        }
      >
        <i className="fas fa-wand-magic-sparkles" aria-hidden />
        <span>{summaryLoading ? "Summarising…" : label}</span>
      </button>

      <ScheduleActivityAiSummaryModal
        open={summaryOpen}
        onClose={() => setSummaryOpen(false)}
        loading={summaryLoading}
        error={summaryError}
        summary={summary}
        isScheduleLive={isScheduleLive}
      />
    </>
  );
}
